import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  shareInfo: {
    id: 'components.ShareLg.shareInfo',
    defaultMessage: 'Udostępnij:'
  }
});



// WEBPACK FOOTER //
// ./src/common/components/ShareLg/ShareLg.intl.js